import { useCallback, useMemo } from 'react';
import { prop, isEmpty, path } from 'ramda';
import { useDeviceSelector, useGameConfigurationSelector } from 'js/store/hooks';
import { getGame } from 'js/components/common/Game/helpers';

export const useGameConfig = (code) => {
    const games = useGameConfigurationSelector(prop('games'));
    const isDesktop = useDeviceSelector(prop('isDesktop'));

    const getGameConfigByCode = useCallback((gCode) => {
        const game = getGame(gCode)(games);
        const {
            gameCode,
            seoFriendlyGameName,
            gameTileAssetsLandscape,
            defaultGameImage
        } = game;

        if (isEmpty(game)) {
            return game;
        }

        const imageKeyBase = isDesktop ? 'mainImage' : 'mobileImage';
        const imageKeyGuest = isDesktop ? 'guestMainImage' : 'guestMobileImage';
        const longImg = gameTileAssetsLandscape?.layout1x2?.[imageKeyBase] || defaultGameImage;
        const imagesBase = gameTileAssetsLandscape?.layout1x1?.[imageKeyBase];
        const imagesGuest = gameTileAssetsLandscape?.layout1x1?.[imageKeyGuest];

        return {
            ...game,
            gameUrlFragment: seoFriendlyGameName || gameCode,
            longImg,
            images: { base: imagesBase, guest: imagesGuest, longImg }
        };
    }, [games, isDesktop]);

    const config = useMemo(() => {
        return getGameConfigByCode(code);
    }, [code, getGameConfigByCode]);

    return { ...config, getGameConfigByCode };
};

export const useGameUrlFragment = (code) => {
    const { seoFriendlyGameName } = useGameConfigurationSelector(path(['games', code])) || {};

    return seoFriendlyGameName || code;
};
